import * as React from 'react';
import { useState } from 'react';

import classNames from 'classnames';

import createLoadableComponent from 'js/lib/createLoadableComponent';

import { Box, Button, Divider } from '@coursera/coursera-ui';

import withSingleTracked from 'bundles/common/components/withSingleTracked';
import AuthFormFooter from 'bundles/user-account/components/AuthFormFooter';

import _t from 'i18n!nls/user-account';

import 'css!./__styles__/AuthenticationModal';

const LoadableSSOAuthFormV1 = createLoadableComponent(() => import('bundles/user-account/components/SSOAuthFormV1'));

const TrackedButton = withSingleTracked({ type: 'BUTTON' })(Button);

function getTranslations(): { [name: string]: string } {
  return {
    SIGN_UP_WITH_ORG: _t('Sign up with your organization'),
    SIGN_IN_WITH_ORG: _t('Log in with your organization'),
    OR: _t('or'),
  };
}

type Props = {
  tag: React.ComponentType<any>;
  formProps: {
    authProvider?: string;
    isEnterprise: boolean;
    completeMode?: string;
    onSuccess: () => void;
  };
  isSignUp: boolean;
  disableSignupLoginWithOrgButton: boolean;
};

export default function AuthenticationModalContentV1({
  tag: Form,
  formProps,
  isSignUp,
  disableSignupLoginWithOrgButton,
}: Props) {
  const [showSSOAuthForm, setShowSSOAuthForm] = useState(false);
  const _T = getTranslations();
  const continueWithOrganizationClassName = classNames('m-b-1', 'continue-with-organization', 'fw-bold', 'w-100');

  const toggleSSOAuthForm = () => setShowSSOAuthForm(!showSSOAuthForm);

  return (
    <Box rootClassName="AuthenticationModalContentV1" flexDirection="column">
      {!showSSOAuthForm && (
        <Box flexDirection="column">
          <Form {...formProps} />
          {!disableSignupLoginWithOrgButton && (
            <div>
              <div aria-hidden="true">
                <Divider>
                  <span className="m-y-1 text-muted text-sm"> {_T.OR}</span>
                </Divider>
              </div>
              <TrackedButton
                rootClassName={continueWithOrganizationClassName}
                type="link"
                size="zero"
                label={isSignUp ? _T.SIGN_UP_WITH_ORG : _T.SIGN_IN_WITH_ORG}
                onClick={toggleSSOAuthForm}
                trackingName={isSignUp ? 'sign_up_with_organization_btn_click' : 'login_with_organization_btn_click'}
              />
            </div>
          )}
        </Box>
      )}
      {showSSOAuthForm && <LoadableSSOAuthFormV1 onBack={toggleSSOAuthForm} isSignUp={isSignUp} />}
      {isSignUp && !showSSOAuthForm && <AuthFormFooter authMode="signup" />}
    </Box>
  );
}
